// Copyright (c) 2020 Deere & Company

import EditableField from './editable-field';
import LabeledFormInput from './labeled-form-input';
import PropTypes from 'prop-types';
import React from 'react';

const LabeledInput = ( {
    className, highlightClass, isEditable, value, link, formatter, label, isRequired, labelNeedsTranslation, type = 'text', vsrMessage, ...props
} ) => (
    <LabeledFormInput
        className={`${className} ${highlightClass} labeled-input`}
        label={label}
        isRequired={isRequired}
        labelNeedsTranslation={labelNeedsTranslation}
    >
        <EditableField
            isEditable={isEditable}
            value={formatter ? formatter( value ) : value}
            link={link}
        >
            <input
                {...props}
                onChange={props.onChange}
                type={type}
                value={value}
                disabled={props.disabled}
            />
        </EditableField>
    </LabeledFormInput>
);

LabeledInput.displayName = 'LabeledInput';
LabeledInput.propTypes = {
    className: PropTypes.string,
    formatter: PropTypes.func,
    highlightClass: PropTypes.string,
    isEditable: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    labelNeedsTranslation: PropTypes.bool,
    onChange: PropTypes.func,
    type: PropTypes.string,
    value: PropTypes.oneOfType( [PropTypes.string, PropTypes.number] ),
    link: PropTypes.string,
    vsrMessage: PropTypes.string,
    isRequired: PropTypes.bool,
    disabled: PropTypes.bool
};

export default LabeledInput;
